<template>
    <b-card-body>
        <b-card bg-variant="light">

            <b-form-row @keyup.enter="load">
                <b-col lg="2" sm="12" class="text-left">
                    <lg-form-const-select label="Situação:" v-model="form.situacao"
                        :options="form.optionsFilterSituacao" @change="load" />
                </b-col>
                <b-col lg="8" sm="10" class="text-left">
                    <lg-form-input v-model="form.descricao" label="Descrição:" description=" " />
                </b-col>
                <b-col cols="2" class="text-right mt-2">

                    <b-button id="limpar-unidade-almoxarifado" class="my-2" size="sm" style="height: 20px" pill
                        variant="primary" @click="limpar">
                        <div class="btn-size-alinhamento">
                            <b-icon icon="eraser" />
                        </div>
                        <b-tooltip target="limpar-unidade-almoxarifado" title="Limpar"></b-tooltip>
                    </b-button>
                    <b-button id="btnPesquisar" class="mr-2 my-2" size="sm" style="height: 20px" pill variant="primary"
                        @click="load">
                        <b-tooltip :target="'btnPesquisar'" title="Localizar"></b-tooltip>
                        <div class="btn-size-alinhamento">
                            <b-icon icon="search" />
                        </div>
                    </b-button>
                    <b-button id="novo-Almoxarifado-Departamento" class=" my-2" size="sm" style="height: 20px" pill
                        variant="primary" @click="mostrarModal">
                        <div class="btn-size-alinhamento">
                            <b-icon scale="1" icon="plus" /> &nbsp;
                        </div>
                        <b-tooltip target="novo-Almoxarifado-Departamento" title="Adicionar novo..."></b-tooltip>

                    </b-button>

                </b-col>
            </b-form-row>
        </b-card>

        <b-card bg-variant="light">
            <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records" :fields="this.tableFields"
                :hover="true" show-empty>
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>

                <template #empty>
                    <p>
                        Nenhum Registro encontrado
                    </p>
                </template>

                <template v-slot:cell(excluir)="row">
                    <b-button :id="row.index + 'excluir-unidade-almoxarifado'" class="my-2" size="sm" pill
                        variant="primary" @click="remove(row.item)">
                        <b-icon icon="trash-fill" />
                        <b-tooltip :target="row.index + 'excluir-unidade-almoxarifado'" title="Remover..."></b-tooltip>
                    </b-button>
                </template>


                <template v-slot:cell(situacao)="row">
                    <div :id="row.index + 'switch'">
                        <b-form-checkbox v-model="row.item.situacao" name="check-button" switch size="lg" :value="1"
                            @change="alteraSituacao(row.item)" :unchecked-value="0"
                            :disabled="!temPrivilegioEdicao()" />
                        <b-tooltip :target="row.index + 'switch'" title="Ativo/Inativo..."></b-tooltip>
                    </div>
                </template>
            </b-table>

            <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                        {{
                            totalPage }} -
                        {{ total }} registros</b-col>
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                        <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                            :options="perPageOptions">
                        </b-form-select>
                    </b-col>
                </b-col>
                <b-col cols="6">
                    <div class="d-flex justify-content-end align-items-end">
                        <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page" :per-page="perPage"
                            :total-rows="total"></b-pagination>
                    </div>
                </b-col>
            </b-row>
        </b-card>
        <ModalPageUnidadeAdministrativa :id="'finder-Almoxarifado-Departamento'" v-if="showUnidade"
            @onselect="addUnidadeSelect" :prefix="prefix + title + ' > '"></ModalPageUnidadeAdministrativa>

    </b-card-body>
</template>

<script>
import ResourceService from "@/core/api/ResourceService";
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource";
import { FormResourceMixin } from "@/core/mixins/resource";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import ModalPageUnidadeAdministrativa from "@/core/components/Modals/ModalPageUnidadeAdministrativa.vue";


export default {
    components: {
        ModalPageUnidadeAdministrativa,
        LgFormConstSelect,
        LgFormInput
    },
    props: {
        almoxarifado: {
            type: Object,
            default: null,
        },
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Configuração Almoxarifado",
        },
        currentSubgrupo: Object,
    },
    data() {
        return {
            showUnidade: false,

            page: 1,
            perpage: 10,
            perPageOptions: [10, 25, 50, 100],

            form: {

                descricao: "",
                situacao: 1,
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: null },
                    { key: "filterSituacao", text: "Ativo", value: 1 },
                    { key: "filterSituacao", text: "Inativo", value: 0 },
                ],
            },

        }
    },
    mixins: [ListResourceMixin, ConfirmMixin, FormResourceMixin],

    async beforeMount() {
        this.$service = new ResourceService(`api/almoxarifados/${this.almoxarifado.id}/departamentos`)
        this.load();
    },
    methods: {
        async addUnidadeSelect(departamento) {
            try {
                await this.$service.get(`departamento/${departamento.id}`);
                this.$notify({
                    type: "danger",
                    message: "Este registro já está cadastrado",
                });


            }
            catch (error) {
                var form = {}

                form.almoxarifado = this.almoxarifado.id;
                form.principal = 0;
                form.situacao = 1;
                form.departamento = { id: departamento.id };
                await this.$saveResource(form, "", false, {}, false, true);
                this.showUnidade = false;
                this.load();

            }
        },
        mostrarModal() {
            this.showUnidade = true;
        },
        limpar() {
            this.form.situacao = 1;
            this.form.descricao = "";
            this.load();
        },
        async remove(item) {
            await this.$removeResource(item)
        },

        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " o Almoxarifado Departamento?",
                item.departamento.toUpperCase()
            )
            if (response == true) {
                this.confirmarAlteracaoSituacao(item)
            } else {
                item.situacao = item.situacao === 1 ? 0 : 1
            }
        },


        async confirmarAlteracaoSituacao(item) {
            const { status } = await this.$service.alteraSituacao(item);
            if (status == 200) {
                this.$notify({
                    type: "success",
                    message: `Registro ${item.situacao ? "Ativado" : "Desativado"
                        } com sucesso!`,
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: `Erro ao ${item.situacao ? "Ativar" : "Desativar"
                        } o registro!`,
                })
            }
        },

        temPrivilegioEdicao() {
            return verificaPrivilegio(PrivilegiosEnum.CAD_ESSENC_EDITAR);

        },
        async load() {

            var filtro = {};

            if (this.form.situacao != null)
                filtro.situacao = this.form.situacao;


            if (this.form.descricao && this.form.descricao != "")
                filtro.descricao = this.form.descricao;

            this.busy = true;

            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: filtro,

            });
            this.busy = false;

        },

    },
    computed: {
        tableFields() {
            return [
                {
                    key: "sigla",
                    label: "Sigla",
                    thStyle: "font-size: 10px; font-weight: 400;",
                    tdStyle: "font-size: 10px",
                },
                {
                    key: "departamento",
                    label: "Unidades Administrativas",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "situacao",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
                {
                    key: "excluir",
                    label: "",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                    tdClass: "w-1",
                },
            ]
        },

    },
    watch: {
        page() {
            this.load()
        },
    },


}
</script>